import { DocumentType } from './alldocuments-types.model';

export const DOCUMENT_TYPES: DocumentType[] = [
  { code: '305', label: 'allDocuments.documentTypes.taxInvoice', icon: 'pi pi-file', routerLink: '/dashboard/add-invoice' },
  { code: '320', label: 'allDocuments.documentTypes.invoiceWithReceipt', icon: 'pi pi-file-excel', routerLink: '/dashboard/add-invoice-with-receipt' },
  { code: '332', label: 'allDocuments.documentTypes.financialRequest', icon: 'pi pi-dollar', routerLink: '/dashboard/add-finaical-request' },
  { code: '400', label: 'allDocuments.documentTypes.receipt', icon: 'pi pi-book', routerLink: '/dashboard/add-receipts' },
  { code: '330', label: 'allDocuments.documentTypes.reverseInvoice', icon: 'pi pi-undo', routerLink: '/dashboard/add-reverce-invoice' },
  { code: '430', label: 'allDocuments.documentTypes.ReverseReceipt', icon: 'pi pi-file-o', routerLink: '/dashboard/reversereceipt' },
  { code: '100', label: 'allDocuments.documentTypes.order', icon: 'pi pi-shopping-cart', routerLink: '/dashboard/add-order' },
  { code: '200', label: 'allDocuments.documentTypes.mission', icon: 'pi pi-briefcase', routerLink: '/dashboard/add-mission' },
  { code: '0', label: 'allDocuments.documentTypes.offerPrice', icon: 'pi pi-tag', routerLink: '/dashboard/add-offer-price' },
];

/*
Component paths based on document type:

Tax Invoice (305):
Create: c:/work/invoices/Fawtara-Front-End/src/app/Data/invoice/add-invoice/add-invoice.component.ts
Edit: c:/work/invoices/Fawtara-Front-End/src/app/Data/invoice/update-invoice/update-invoice.component.ts

Invoice With Receipt (320):
Create: c:/work/invoices/Fawtara-Front-End/src/app/Data/invoice-with-receipt/add-invoice-with-receipt/add-invoice-with-receipt.component.ts
Edit: c:/work/invoices/Fawtara-Front-End/src/app/Data/invoice-with-receipt/update-invoice-with-receipt/update-invoice-with-receipt.component.ts

Financial Request (332):
Create: c:/work/invoices/Fawtara-Front-End/src/app/Data/financial-request/add-financial-request/add-financial-request.component.ts
Edit: c:/work/invoices/Fawtara-Front-End/src/app/Data/financial-request/update-financial-request/update-financial-request.component.ts

Receipt (400):
Create: c:/work/invoices/Fawtara-Front-End/src/app/Data/receipt/add-receipts/add-receipts.component.ts
Edit: c:/work/invoices/Fawtara-Front-End/src/app/Data/receipt/update-receipts/update-receipts.component.ts

Reverse Invoice (330):
Create: c:/work/invoices/Fawtara-Front-End/src/app/Data/reverse-invoice/add-reverse-invoice/add-reverse-invoice.component.ts
Edit: c:/work/invoices/Fawtara-Front-End/src/app/Data/reverse-invoice/update-reverse-invoice/update-reverse-invoice.component.ts

Order (100):
Create: c:/work/invoices/Fawtara-Front-End/src/app/Data/order/add-order/add-order.component.ts
Edit: c:/work/invoices/Fawtara-Front-End/src/app/Data/order/update-order/update-order.component.ts

Mission (200):
Create: c:/work/invoices/Fawtara-Front-End/src/app/Data/mission/add-mission/add-mission.component.ts
Edit: c:/work/invoices/Fawtara-Front-End/src/app/Data/mission/update-mission/update-mission.component.ts

Offer Price (000):
Create: c:/work/invoices/Fawtara-Front-End/src/app/Data/offer-price/add-offer-price/add-offer-price.component.ts
Edit: c:/work/invoices/Fawtara-Front-End/src/app/Data/offer-price/update-offer-price/update-offer-price.component.ts
*/

// 300 & 325 not there in the code